import { t } from 'i18next'
import { Avatar } from 'primereact/avatar'
import React from 'react'
import { Apprentice, Person } from '../../model/person.model'

import { getUserAvatarSrc } from '../../util/getAvatar'
import { getPersonName } from '../../util/getPersonName'

export const AvatarWithNameForDropdown = (props: {
  person: Person;
}): JSX.Element => {
  return (
    <span
      key={props.person.person_id}
      className={'justify-content-center p-0 m-0'}
    >
      <Avatar
        image={getUserAvatarSrc(props.person)}
        size={'normal'}
        shape="circle"
        className={'dropdown-avatar'}
        imageAlt={''}
        style={{ padding: '0 !important', margin: '0 !important' }}
        onImageError={() => ''}
      />
      <span className={'person-name'}>{getPersonName(props.person)}</span>
    </span>
  )
}

export const AvatarWithName = (props: { person: Person }): JSX.Element => {
  return (
    <span key={props.person.person_id} className={'justify-content-center'}>
      <Avatar
        image={getUserAvatarSrc(props.person)}
        size={'normal'}
        shape="circle"
        className={'circle avatar'}
        imageAlt={''}
        onImageError={() => ''}
      />
      <span className={'person-name'}>
        {getPersonName(props.person)}
        {props.person.is_active !== 1 && (
          <span className={'small-text '}> - {t<string>('core.inactive')}</span>
        )}
      </span>
    </span>
  )
}

export const BigApprenticeAvatarWithName = (props: {
  apprentice: Apprentice | undefined;
}): JSX.Element => {
  return (
    <span
      key={props.apprentice?.person_id}
      className={'flex align-items-center'}
    >
      <Avatar
        image={getUserAvatarSrc(props.apprentice)}
        size={'xlarge'}
        shape="circle"
        className={'ml-1 mr-2'}
        imageAlt={''}
        onImageError={() => ''}
      />
      <span className={'person-name'}>
        {getPersonName(props.apprentice)}
        {props.apprentice?.is_active !== 1 && (
          <span className={'small-text'}> - {t<string>('core.inactive')}</span>
        )}
      </span>
    </span>
  )
}